import { LogLevel } from '@azure/msal-browser';
import { logger } from 'utils/logger';

/**
 * MSAL configuration for signing in with Microsoft 365 (Entra ID) SSO.
 * See: https://github.com/AzureAD/microsoft-authentication-library-for-js
 */
export const msalConfig = {
  auth: {
    clientId: import.meta.env.VITE_APP_SSO_CLIENT_ID,
    authority: import.meta.env.VITE_APP_SSO_AUTHORITY,
    redirectUri: '/',
  },
  cache: {
    cacheLocation: 'localStorage' as const,
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level: LogLevel, message: string, containsPii: boolean) => {
        if (containsPii) return;
        switch (level) {
          case LogLevel.Error:
            logger.error(message);
            return;
          case LogLevel.Warning:
            logger.warn(message);
            return;
          default:
            logger.debug(message);
        }
      },
    },
  },
};

/**
 * The backend validates the Microsoft-issued ID token as a bearer token
 * (see the UAM CMS Backend Postman collection), so we only need the
 * default OIDC scopes here - no additional API scopes to request.
 */
export const loginRequest = {
  scopes: ['User.Read', 'openid', 'profile'],
};
